import {
  PudoSearchResponseData,
  HscodeSearchRequestData,
  HscodeSearchResponseData,
} from '../models/apiResponse';
import { PudoSearch } from '../models/pudoSearchRequest';
import { apiRequests as requests } from './http-client';
import {
  FIVE_MINUTE_POST_CACHE_CONFIG,
  FORTY_FIVE_SECOND_POST_CACHE_CONFIG,
} from './cache-config';

const Search = {
  searchPudo: (carrier: string, pudoSearch: PudoSearch) =>
    requests
      .post<PudoSearchResponseData>(
        `/v1/search/pudo/${carrier}`,
        pudoSearch,
        FORTY_FIVE_SECOND_POST_CACHE_CONFIG
      )
      .then((response) => response),
  hscode: (searchRequest: HscodeSearchRequestData) =>
    requests
      .post<HscodeSearchResponseData>(
        `/v1/search/hscode`,
        searchRequest,
        FIVE_MINUTE_POST_CACHE_CONFIG
      )
      .then((response) => response.data),
};

export default Search;
